export const diagnosiModified = (diagnosi) => {
    if (diagnosi && typeof diagnosi === 'object') {
        const quesitoModificato = (diagnosi.quesito || "").trim() !== "";
        const itemsModificati = Array.isArray(diagnosi.items) && diagnosi.items.length > 0;
        return quesitoModificato || itemsModificati;
    }
    return false;
};


export const esamiPrecedentiModified = (esamiPre) => {
    if (esamiPre && Array.isArray(esamiPre)) {
        return esamiPre.some(
            (item) =>
                ((item.nomeEsame || "").trim() !== "") ||
                ((item.dataEsame || "").trim() !== "") ||
                ((item.esito || "").trim() !== "")
        );
    }
    return false;
};

export const allergieModified = (allergie) => {
    if (allergie) {
        return (
            ((allergie.allergene || "").trim() !== "") ||
            ((allergie.severita || "").trim() !== "") ||
            ((allergie.stato || "").trim() !== "")
        );
    }
    return false;
};

export const conclusioniModified = (conclusioni) => {
    return (conclusioni || "").trim() !== "";
};

export const suggerimentiModified = (suggerimentiMedico) => {
    return (suggerimentiMedico || "").trim() !== "";
};